import { FC, memo } from 'react'

import { Form } from 'brief-form'
import { SearchInputDebounced } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter'
import { TableFilterRow } from 'ui/temp/TableFilterRow'

import { FilterProps } from './FilterProps'

import * as SC from './styles'

export const Filter: FC<FilterProps> = memo((props) => {
  const { isDirty, isExpanded, onClear, onToggle, form, webPage, searchValue, onSearch } = props
  const { config, Field } = form

  return (
    <FilterPanel
      isDirty={isDirty}
      onReset={onClear}
      expanded={isExpanded}
      onToggle={onToggle}
      customActions={
        <SearchInputDebounced
          onChange={onSearch}
          value={searchValue}
          placeholder="Search by License Name"
          data-qa="Search"
        />
      }
    >
      <FilterWrapper>
        <Form config={config}>
          <TableFilterRow>
            <SC.ItemWrapper>
              <Field
                name="connectionType"
                label="Connection Type"
                input={Select}
                inputProps={{
                  data: webPage.connectionTypes
                }}
              />
            </SC.ItemWrapper>
            <SC.ItemWrapper>
              <Field
                name="isConnected"
                label="Status"
                input={Select}
                inputProps={{
                  data: webPage.connectedStatuses
                }}
              />
            </SC.ItemWrapper>
          </TableFilterRow>
        </Form>
      </FilterWrapper>
    </FilterPanel>
  )
})
